import { api } from '@/shared/api/axios'
import type { ApiResponse } from '@/shared/types/auth.types'

export type SettingValueType = 'STRING' | 'NUMBER' | 'BOOLEAN' | 'JSON'

export interface SettingDTO {
  id: number
  institutionId?: number | null
  institutionName?: string | null
  key: string
  value?: string | null
  type: SettingValueType
  description?: string | null
  category?: string | null
  createdAt?: string
  updatedAt?: string
}

export interface SettingUpdatePayload {
  value?: string | null
  type?: SettingValueType
  description?: string | null
  category?: string | null
}

export const settingService = {
  getAll: async (): Promise<SettingDTO[]> => {
    const res = await api.get<ApiResponse<SettingDTO[]>>('/settings')
    return res.data.data
  },

  getByKey: async (key: string): Promise<SettingDTO> => {
    const res = await api.get<ApiResponse<SettingDTO>>(`/settings/key/${encodeURIComponent(key)}`)
    return res.data.data
  },

  getEnabledModules: async (): Promise<Record<string, boolean>> => {
    const res = await api.get<ApiResponse<Record<string, boolean>>>('/settings/enabled-modules')
    return res.data.data
  },

  create: async (payload: {
    key: string
    type: SettingValueType
    value?: string | null
    description?: string | null
    category?: string | null
    institutionId?: number | null
  }): Promise<SettingDTO> => {
    const res = await api.post<ApiResponse<SettingDTO>>('/settings', payload)
    return res.data.data
  },

  update: async (id: number, payload: SettingUpdatePayload): Promise<SettingDTO> => {
    const res = await api.put<ApiResponse<SettingDTO>>(`/settings/${id}`, payload)
    return res.data.data
  },
}
